import { useState, useEffect, useRef } from 'react';
import { Col, Row } from 'antd';
import { FormItem, Select } from 'formik-antd';

import { useAppSelector } from 'hooks/useAppSelector';
import { isAdminSelector } from 'redux/selectors/authenticationSelectors';
import { customerGroupsSelector } from 'redux/selectors/clientSelectors';
import { CustomerGroup } from 'api/adminApiClient';
import AddCustomerGroupButton from './AddCustomerGroupButton';
import { ClientCreationEnum } from '../../enum';

import styles from './CustomerGroupForm.module.less';

export interface CustomerGroupOption {
  label: CustomerGroup['name'];
  value: CustomerGroup['id'] | CustomerGroup['name'];
}

interface Props {
  creationType: ClientCreationEnum;
}

export default function CustomerGroupForm(props: Props) {
  const { creationType } = props;

  const customerGroupFieldRef: any = useRef();

  const isAdminRole = useAppSelector(isAdminSelector);
  const customerGroups = useAppSelector(customerGroupsSelector);

  const [customerGroupOptions, setCustomerGroupOptions] = useState<
    CustomerGroupOption[]
  >([]);

  const customerGroupField =
    creationType === ClientCreationEnum.EditImport
      ? 'customerGroupName'
      : 'customerGroupId';

  useEffect(() => {
    let mappedCustomerGroups = [];

    if (creationType === ClientCreationEnum.EditImport) {
      mappedCustomerGroups = customerGroups.map(({ name }) => ({
        label: name,
        value: name,
      }));
    } else {
      mappedCustomerGroups = customerGroups.map(({ id, name }) => ({
        label: name,
        value: id,
      }));
    }

    setCustomerGroupOptions(mappedCustomerGroups);
  }, [customerGroups, creationType]);

  if (!isAdminRole) {
    return null;
  }

  return (
    <Row gutter={40}>
      <Col xs={24} md={12} ref={customerGroupFieldRef}>
        <div className={styles.container}>
          <FormItem
            name={customerGroupField}
            label="Customer Group"
            data-id="newClientCustomerGroupField"
            className={styles.formItem}
          >
            <Select
              name={customerGroupField}
              placeholder="Select customer group"
              className={styles.select}
            >
              {customerGroupOptions.map((customerGroupOption) => (
                <Select.Option
                  key={`customer-group-${customerGroupOption.value}`}
                  value={customerGroupOption.value}
                >
                  {customerGroupOption.label}
                </Select.Option>
              ))}
            </Select>
          </FormItem>

          <AddCustomerGroupButton
            customerGroupOptions={customerGroupOptions}
            className={styles.addButton}
            popoverProps={{
              getPopupContainer: () => customerGroupFieldRef.current,
            }}
          />
        </div>
      </Col>
    </Row>
  );
}
